import { ConfiguracionCanal } from "@/core/models";


export class ChannelConfigurationRule {
  /**
   * Devuelve el color principal del canal.
   */
  public static getPrimaryColor(configurationChannel: ConfiguracionCanal | null): string | null {
    if (!configurationChannel) return null;

    return configurationChannel?.configuracion?.selectWebsiteColor ?? null;
  }
}